var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "time-select" },
    _vm._l(_vm.timeList, function (item, i) {
      return _c(
        "div",
        {
          key: i,
          staticStyle: {
            display: "flex",
            align: "center",
            "margin-bottom": "15px",
          },
        },
        [
          _c("el-time-picker", {
            attrs: {
              format: "HH:mm",
              "value-format": "HH:mm",
              placeholder: "选择时间",
            },
            on: { change: _vm.changeVal },
            model: {
              value: item.startTime,
              callback: function ($$v) {
                _vm.$set(item, "startTime", $$v)
              },
              expression: "item.startTime",
            },
          }),
          _vm._v(" "),
          _vm.showEndTime
            ? [
                _c("div", { staticStyle: { margin: "0 10px" } }, [
                  _vm._v("至"),
                ]),
                _vm._v(" "),
                _c("el-time-picker", {
                  attrs: {
                    format: "HH:mm",
                    "value-format": "HH:mm",
                    placeholder: "选择时间",
                  },
                  on: { change: _vm.changeVal },
                  model: {
                    value: item.endTime,
                    callback: function ($$v) {
                      _vm.$set(item, "endTime", $$v)
                    },
                    expression: "item.endTime",
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "el-icon-circle-plus",
            staticStyle: {
              color: "green",
              "font-size": "21px",
              "line-height": "34px",
              margin: "0 10px",
            },
            on: { click: _vm.addTime },
          }),
          _vm._v(" "),
          i > 0
            ? _c("div", {
                staticClass: "el-icon-remove",
                staticStyle: {
                  color: "red",
                  "font-size": "21px",
                  "line-height": "34px",
                },
                on: {
                  click: function ($event) {
                    return _vm.removeTime(i)
                  },
                },
              })
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }